import type {
  GenerateExcludedItemsList,
  GenerateUniqueSourceList,
  TExtractTagsAndUsername,
  GenerateDescriptionList,
  GetEditedDescription,
  GenerateHref,
  GenerateLink,
  GetLink,
} from './types';

const hashtagOrUserSearchRegexp = /[@#][^\s!@#$%^&*()=+./,\[{\]};:'"?><]+/gi;

const getEditedDescription: GetEditedDescription = text => {
  const hashtagRegEx = /#/g;
  const usernameRegEx = /@/g;

  const tagReplacedText = text.replace(hashtagRegEx, ' #');
  return tagReplacedText.replace(usernameRegEx, ' @');
};

const generateDescriptionList: GenerateDescriptionList = text => text.split('\n');

const generateLink: GenerateLink = text => {
  const parts = text.split(' ');
  const data = [];

  parts.forEach(part => {
    if (part) {
      const href = getLink(part);
      if (href || data.length === 0 || data[data.length - 1].href) {
        data.push({ text: part, href });
      } else {
        data[data.length - 1].text = data[data.length - 1].text.concat(` ${part}`);
      }
    }
  });

  return data;
};

const linkRegEx = /\b(?:((http|https):\/\/)?picsart\.com\/|((http|https):\/\/)?youtube\.com\/)\b/;
const getLink: GetLink = part => {
  let href;
  if (part[0] === '#' && part.length > 1) {
    href = generateHref(part, 'hashtag');
  } else if (part[0] === '@' && part.length > 1) {
    href = generateHref(part, 'u');
  } else if (part.match(linkRegEx)) {
    href = part;
  }
  return href;
};

const regExEnd = /%|,/m;
const generateHref: GenerateHref = (part, type) => {
  const match = encodeURI(part).match(regExEnd);
  const path = part.substring(1, match?.index || part.length);

  return `/${type}/${path}`;
};

const generateUniqueSourceList: GenerateUniqueSourceList = list => [
  ...new Set(list.map(item => item.username)),
];

const generateExcludedItemsList: GenerateExcludedItemsList = (list, text, char) => {
  const textSet = new Set();
  const parts = text.split(' ');
  parts.forEach(item => {
    textSet.add(item);
  });
  return list.filter(item => !textSet.has(`${char}${item}`));
};

const extractTagsAndUsername: TExtractTagsAndUsername = title => {
  let match = hashtagOrUserSearchRegexp.exec(title);
  const usernameChar = '@';
  const hashtags: Set<string> = new Set();
  let description = title;
  let username = '';
  while (match) {
    const [inputResult] = match;
    const len = inputResult.length;
    if (len < 50) {
      const slice = inputResult.slice(1);
      const isUsername = inputResult.charAt(0) === usernameChar;
      if (isUsername) {
        username = slice;
      } else {
        hashtags.add(slice);
      }
    }
    description = description.replace(inputResult, '');
    match = hashtagOrUserSearchRegexp.exec(title);
  }
  return {
    description: description.trim(),
    username,
    hashtags,
  };
};

export {
  generateExcludedItemsList,
  generateUniqueSourceList,
  generateDescriptionList,
  extractTagsAndUsername,
  getEditedDescription,
  generateLink,
  generateHref,
};
